export default "__VITE_ASSET__DneX$k$H__"